export const ensurePdfExtension = (url: string): string => (url.endsWith('.pdf') ? url : `${url}.pdf`);
